/**
 * Lenkemalen for kundeoppslaget (`customerLookupUrlTemplate`, «Kundeoppslag for kundeservice»
 * i tech-decisions.md): tjenerens regel speilet i panelet, så foten kan sperres med grunnen FØR
 * forespørselen — tjenerens melding vises aldri (DD-50, «forklarte låser»).
 *
 * Regelen er den samme som i `SettingsService`: https, høyst 500 tegn, «{sub}» nøyaktig én gang
 * og ingen annen plassholder i krøllparenteser. Tom mal er lov: den slår kundeoppslaget av.
 */
export const KUNDEOPPSLAG_MAKS = 500;

/** Grunnen til at malen ikke kan lagres som den står — eller `null`. Første brudd vinner. */
export function kundeoppslagGrunn(mal: string): string | null {
  const m = mal.trim();
  if (!m) return null;
  if (!m.startsWith('https://')) return 'Lenkemalen må begynne med https://';
  if (m.length > KUNDEOPPSLAG_MAKS) return 'Lenkemalen er for lang.';
  if (m.split('{sub}').length !== 2) return 'Lenkemalen må ha {sub} nøyaktig én gang.';
  if (/\{(?!sub\})[^}]*\}/.test(m)) return 'Bare {sub} kan stå i krøllparenteser.';
  return null;
}

/** Vertsnavnet i malen — det verdilinjen viser («På · intern.example»), aldri hele adressen. */
export function kundeoppslagVert(mal: string): string {
  try {
    return new URL(mal).host;
  } catch {
    return mal;
  }
}
